import React, { useState } from 'react';
export const ToggleSwitch = ({ value, onChange, className }) => {
    const [state, setState] = useState(value);
    return (React.createElement("div", { className: 'toggle-switch', onClick: () => {
            setState(!state);
            if (onChange)
                onChange(!state);
        } },
        React.createElement("input", { type: 'checkbox', className: 'toggle-switch__input', checked: state }),
        React.createElement("span", { className: 'toggle-switch__switch' })));
};
//# sourceMappingURL=ToggleSwitch.js.map